import { render, staticRenderFns } from "./Noticias.vue?vue&type=template&id=b641ead8&lang=pug"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports